export default "__VITE_ASSET__DGEKb7fV__"